import "./Our_Community.css";
import CommonBreadcrumb from "./../../common_components/breadcrumb/CommonBreadcrumb";
import { AllShareholder } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const shareholderCards = [
  {
    id: 1,
    type: "static",
    title: "Static Shareholder",
    des:
      "If an IR makes 12 DRs in less than 12 months then he will be entitled as “Static share Holder.” 5% of the total profit will be equally distributed among these static shareholders.",
    condition: "12 direct referrals within 12 months.",
    benefit:
      "5% of total company profit shared equally among all static shareholders",
  },
  {
    id: 2,
    type: "growth",
    title: "Growth Shareholder",
    des:
      "These shareholders are responsible for company’s growth. If an IR Makes 12 DRs and these 12 DRs make 4 customers each in less than 12 months then the IR will be entitled as “Growth Shareholder. 10% of the total profit will be equally distributed among the growth shareholders.",
    condition:
      "12 direct referrals, each of them brings 4 customers within 12 months.",
    benefit:
      "10% of total company profit shared equally among growth shareholders",
  },
];

export default function Our_Community() {
  const dispatch = useDispatch();

  const all_share_holder = useSelector(
    (state) => state?.common?.all_share_holder,
  );

  // useEffect(() => {
  //   dispatch(AllShareholder());
  // }, [dispatch]);
  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Our Community" },
  ];

  return (
    <section className="shareholder-section  our-community-section">
      <CommonBreadcrumb items={breadcrumbItems} />
      <div className="container container-wrapper">
        <h2 className="shareholder-heading">
          Share Holder Club. <span>Extra Income Opportunity</span>
        </h2>

        <p className="shareholder-desc">
          The Share Holder Club rewards members who actively grow the network.
          Complete 12 direct referrals within 12 months to become a Static
          Shareholder and enjoy an equal share of 5% of the company’s total
          profit. Take it further by building a strong team—12 direct referrals,
          each bringing 4 customers within 12 months and qualify as a Growth
          Shareholder, earning an equal share of 10% of the company’s total
          profit.
        </p>

        <div className="sh-wrapper">
          {all_share_holder?.map((item, index) => (
            <div className="sh-card" key={item.id}>
              {/* <div className={`sh-image ${item.type}`}> */}
              <div className="shareholder-image-wrapper">
                <img
                  src={`${IDS.IMG_URL}${item?.image}`}
                  alt={item?.name || "Shareholder level"}
                  className={`shareholder-image ${item?.type || ""}`}
                  onError={(e) => {
                    e.target.src = "/images/placeholder-shareholder.jpg"; // fallback image
                    e.target.alt = "Image not available";
                  }}
                />
                <h3 className="sh-title">
                  {index + 1}. {item?.name}
                </h3>
              </div>

              <div className="sh-body">
                <p className="desc">{item?.des}</p>
                <p className="sh-label">Condition:</p>
                <p className="sh-condition">{item?.condition}</p>

                <p className="sh-label">Benefit:</p>
                <p className="sh-condition sh-benefit">{item?.benifit}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
